<template>
    <div
        :class="['pl-4', { 'mb-2': type === 'table' && !element_item.description }, { 'mb-3': type === 'table' && element_item.description }]">
        <!-- input text 유형 -->
        <template v-if="type === 'input_text'">
            <template v-if="structure.label">
                <div class="mb-1">
                    • {{ showTranslation(structure.label, structure.label_ea, structure.label_ca) }}
                </div>
            </template>

            <div :class="['d-flex align-items-center', { 'ml-4': structure.label }]">
                <template v-if="structure.pre_text">
                    <div class="pr-2">
                        {{ showTranslation(structure.pre_text, structure.pre_text_ea, structure.pre_text_ca) }}
                    </div>
                </template>
                <b-input-group size="sm">
                    <b-form-input
                        v-model="result"
                        :placeholder="showTranslation(structure.placeholder, structure.placeholder_ea, structure.placeholder_ca)"
                        @update="handleUpdate"
                        @blur="handleUpdate('input_text', true)"
                        :disabled="disabled"
                    />
                    <b-input-group-append>
                        <template v-if="structure.after_text">
                            <b-input-group-text class="bgray-100">
                                {{
                                    showTranslation(structure.after_text, structure.after_text_ea, structure.after_text_ca)
                                }}
                            </b-input-group-text>
                        </template>
                        <b-button
                            v-b-modal="`input-text-${code}`"
                            class="f-80"
                            variant="icon-append"
                            :disabled="disabled"
                        >
                            <fa icon="pen"></fa>
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </div>
            <div v-if="has_sub_attachment(result, 'input_text')" class="rounded mb-3 border-0 f-95 p-2 bg-tealgray100">
                <df-attached-file-url-sub
                    v-bind="for_attachment_info"
                    class="mt-1"
                    :key="for_attachment_info.is_loaded + Math.random()"
                    :sub_code="sub_code"
                    :sub_path="`structure[${item_idx}].element_contents[${element_idx}].structure`"
                    :label="label"
                    :disabled="disabled || !result"
                    :audit_mode="audit_mode"
                >
                </df-attached-file-url-sub>
            </div>

            <b-modal :id="`input-text-${code}`"
                     @ok="handleOK" size=""
                     :title="$t('상세설명')"
            >
                <p class="mb-2 f-90 gray-600"> {{ $t('상세설명을 작성하여 주십시오.') }} </p>
                <b-textarea
                    v-model="result"
                    rows="5"
                    :placeholder="showTranslation(structure.placeholder, structure.placeholder_ea, structure.placeholder_ca)"
                    :disabled="disabled"
                />
            </b-modal>
        </template>

        <!-- input number 유형  -->
        <template v-else-if="type === 'input_number'">
            <template v-if="structure.label">
                <div class="mb-1">
                    • {{ showTranslation(structure.label, structure.label_ea, structure.label_ca) }}
                </div>
            </template>

            <div :class="['d-flex align-items-center', { 'ml-4': structure.label }]">
                <template v-if="structure.pre_text">
                    <div class="text-nowrap pr-2">
                        {{ showTranslation(structure.pre_text, structure.pre_text_ea, structure.pre_text_ca) }}
                    </div>
                </template>

                <b-input-group size="sm">
                    <b-form-input
                        v-model="result"
                        @update="handleUpdate"
                        @blur="handleUpdate('input_text', true)"
                        :placeholder="showTranslation(structure.placeholder, structure.placeholder_ea, structure.placeholder_ca)"
                        :disabled="disabled"
                        v-number-format="'number'"
                    />
                    <template v-if="structure.after_text">
                        <b-input-group-append>
                            <b-input-group-text class="bgray-100">
                                {{
                                    showTranslation(structure.after_text, structure.after_text_ea, structure.after_text_ca)
                                }}
                            </b-input-group-text>
                        </b-input-group-append>
                    </template>
                </b-input-group>
            </div>
            <div v-if="has_sub_attachment(result, 'input_number')" class="rounded mb-3 border-0 f-95 p-2 bg-tealgray100">
                <df-attached-file-url-sub
                    v-bind="for_attachment_info"
                    class="mt-1"
                    :key="for_attachment_info.is_loaded + Math.random()"
                    :sub_code="sub_code"
                    :sub_path="`structure[${item_idx}].element_contents[${element_idx}].structure`"
                    :label="label"
                    :disabled="disabled || !result"
                    :audit_mode="audit_mode"
                >
                </df-attached-file-url-sub>
            </div>
        </template>

        <!-- radio 유형 -->
        <template v-else-if="type === 'radio'">
            <b-form-radio-group
                v-model="result"
                :class="structure.some(({ description }) => typeof description !== 'undefined') ? 'w-100' : ''"
                @change="handleUpdate('radio')"
                stacked
            >
                <div v-for="(radio_option, index) in structure"
                     :key="`subs-${sub_code}-radio-element-${element_idx}-option-${index}`"
                     :class="[{ 'mb-1': structure.length - 1 > index }]"
                >


                    <b-form-radio
                        :value="radio_option.value"
                        :class="[{ 'element-check': isIE === true, 'mb-1' : typeof radio_option.description !== 'undefined' }, 'w-100']"
                        :disabled="disabled"
                    >
                        <span
                            v-html="showTranslation(radio_option.text, radio_option.text_ea, radio_option.text_ca)"
                            class="mb-1"></span>

                        <div v-if="has_sub_attachment(radio_option, 'radio')" class="rounded mb-3 border-0 f-95 p-2 bg-tealgray100">
                            <df-attached-file-url-sub
                                v-bind="for_attachment_info"
                                class="mt-1"
                                :key="for_attachment_info.is_loaded + Math.random()"
                                :sub_code="sub_code"
                                :sub_path="`structure[${item_idx}].element_contents[${element_idx}].structure[${index}]`"
                                :disabled="disabled || !result"
                                :label="label"
                                :audit_mode="audit_mode"
                            >
                            </df-attached-file-url-sub>
                        </div>
                        <template
                            v-if="radio_option.description != null || radio_option.description_input_type != null">
                            <div :class="['input-description', 'mt-1', { 'mb-2' : structure.length - 1 > index}]">
                                <b-input-group
                                    class="w-100 mb-2"
                                    style=""
                                >
                                    <template
                                        v-if="radio_option?.description_input_type && radio_option.description_input_type === 'numbder'">
                                        <b-form-input class="f-90"
                                                      v-model="radio_option.description"
                                                      :type="radio_option.description_input_type"
                                                      :disabled="!result.includes(radio_option.value) || disabled"
                                                      :placeholder="showTranslation(radio_option.placeholder || '상세설명', radio_option.placeholder_ea || 'specific comment', radio_option.placeholder_ca || '详细说明')"
                                                      v-number-format="'number'"
                                                      @change="handleUpdate"
                                                      @blur="handleUpdate('input_text', true)"
                                        />
                                    </template>
                                    <template v-else>
                                        <b-form-input
                                            v-model="radio_option.description"
                                            :type="typeof radio_option.description_input_type === 'undefined' ? 'text' : radio_option.description_input_type"
                                            :disabled="!result.includes(radio_option.value) || disabled"
                                            :placeholder="showTranslation(radio_option.placeholder || '상세설명', radio_option.placeholder_ea || 'specific comment', radio_option.placeholder_ca || '详细说明')"
                                            class="f-90"
                                            @change="handleUpdate"
                                            @blur="handleUpdate('input_text', true)"
                                        />
                                    </template>

                                    <b-input-group-append>
                                        <b-button
                                            v-b-modal="`radio-detail-${code}-${index}`"
                                            size="sm"
                                            variant="icon-append"
                                            :disabled="!result.includes(radio_option.value) || disabled"
                                        >
                                            <fa icon="pen"></fa>
                                        </b-button>
                                    </b-input-group-append>
                                </b-input-group>
                                <b-modal :id="`radio-detail-${code}-${index}`"
                                         :title="showTranslation(radio_option.value || '텍스트 상세입력', radio_option.value_ea || $t('텍스트 상세입력'), radio_option.value_ca || $t('텍스트 상세입력'))"
                                         @ok="handleOK"
                                         size="lg"
                                >
                                    <div>
                                        <p class="mb-2 pl-1 f-90"> {{ $t('상세설명을 작성하여 주십시오.') }}</p>
                                        <b-textarea
                                            v-model="radio_option.description"
                                            rows="5"
                                        >
                                        </b-textarea>
                                    </div>
                                </b-modal>
                            </div>
                        </template>
                    </b-form-radio>
                </div>
            </b-form-radio-group>
        </template>

        <!-- checkbox 유형 -->
        <template v-else-if="type === 'checkbox'">
            <b-form-checkbox-group
                v-model="result"
                :class="structure.some(({ description }) => typeof description !== 'undefined') ? 'w-100' : ''"
                @change="handleUpdate('checkbox')"
                stacked
            >
                <div v-for="(checkbox_option, index) in structure"
                     :key="`subs-${sub_code}-checkbox-element-${element_idx}-option-${index}`"
                     :class="[{ 'mb-1': structure.length - 1 > index }]"
                >
                    <b-form-checkbox
                        :value="checkbox_option.value"
                        :class="[{ 'element-check': isIE === true, 'mb-1': typeof checkbox_option.description !== 'undefined' },'w-100']"
                        :disabled="disabled"
                    >
                        <span
                            v-html="showTranslation(checkbox_option.text, checkbox_option.text_ea, checkbox_option.text_ca)"
                            class="mb-1">
                        </span>
                            
                        <div v-if="has_sub_attachment(checkbox_option, 'checkbox')" class="rounded mb-3 border-0 f-95 p-2 bg-tealgray100">
                            <df-attached-file-url-sub
                                v-bind="for_attachment_info"
                                class="mt-1"
                                :key="for_attachment_info.is_loaded + Math.random()"
                                :sub_code="sub_code"
                                :sub_path="`structure[${item_idx}].element_contents[${element_idx}].structure[${index}]`"
                                :label="label"
                                :disabled="disabled || !result"
                                :audit_mode="audit_mode"
                            >
                            </df-attached-file-url-sub>
                        </div>

                        <template v-if="typeof checkbox_option.description !== 'undefined'">
                            <div :class="['input-description', 'mt-1', {'mb-2' : structure.length -1 > index}]">
                                <b-input-group
                                    class="w-100 mb-2"
                                >
                                    <b-form-input
                                        v-model="checkbox_option.description"
                                        :type="typeof checkbox_option.description_input_type === 'undefined' ? 'text' : checkbox_option.description_input_type"
                                        :disabled="!result.includes(checkbox_option.value) || disabled"
                                        :placeholder="showTranslation(checkbox_option.placeholder || '상세설명', checkbox_option.placeholder_ea || 'specific comment', checkbox_option.placeholder_ca || '详细说明')"
                                        class="f-90"
                                        @change="handleUpdate"
                                        @blur="handleUpdate('input_text', true)"
                                    />
                                    <b-input-group-append>
                                        <b-button
                                            v-b-modal="`checkbox-text-${code}-${index}`"
                                            size="sm"
                                            variant="icon-append"
                                            :disabled="!result.includes(checkbox_option.value) || disabled"
                                        >
                                            <fa icon="pen"></fa>
                                        </b-button>
                                    </b-input-group-append>
                                </b-input-group>
                                <b-modal :id="`checkbox-text-${code}-${index}`"
                                         :title="showTranslation(checkbox_option.value || '텍스트 상세입력', checkbox_option.value_ea || $t('텍스트 상세입력'), checkbox_option.value_ca || $t('텍스트 상세입력'))"
                                         @ok="handleOK"
                                         size="lg"
                                >
                                    <div>
                                        <p class="mb-2 pl-1 f-90"> {{ $t('상세설명을 작성하여 주십시오.') }}</p>
                                        <b-textarea
                                            v-model="checkbox_option.description"
                                            rows="5"
                                        >
                                        </b-textarea>
                                    </div>
                                </b-modal>
                            </div>
                        </template>
                    </b-form-checkbox>
                </div>
            </b-form-checkbox-group>

        </template>

        <!-- Table 유형 -->
        <template v-else-if="type === 'table'">
            <template v-if="element_item.table_title">
                <div
                    v-show="($i18n.locale !== 'ko' && (!element_item.table_title_ea || !element_item.table_title_ca)) || ($i18n.locale === 'ko' && element_item.table_title)"
                    class="f-95 mb-1">• {{ element_item.table_title }}
                </div>
                <div v-show="$i18n.locale === 'en' && element_item.table_title_ea" class="f-95 mb-1">•
                    {{ element_item.table_title_ea }}
                </div>
                <div v-show="$i18n.locale === 'ca' && element_item.table_title_ca" class="f-95 mb-1">•
                    {{ element_item.table_title_ca }}
                </div>
            </template>
            <template v-if="element_item.table_description">
                <div
                    v-show="($i18n.locale === 'ko' && (!element_item.table_description_ea || !element_item.table_description_ca)) || ($i18n.locale === 'ko' && element_item.table_description)"
                    :class="['f-90 mb-1', { 'ml-2': element_item.table_title }]">{{ element_item.table_description }}
                </div>
                <div v-show="$i18n.locale === 'en' && element_item.table_description_ea"
                     :class="['f-90 mb-1', { 'ml-2': element_item.table_title }]">{{
                        element_item.table_description_ea
                    }}
                </div>
                <div v-show="$i18n.locale === 'ca' && element_item.table_description_ca"
                     :class="['f-90 mb-1', { 'ml-2': element_item.table_title }]">{{
                        element_item.table_description_ca
                    }}
                </div>
            </template>
            <b-table-simple bordered hover :class="['mb-0', { 'ml-2': element_item.table_title }]">
                <b-thead>
                    <b-tr>
                        <template v-if="$i18n.locale === 'ko'">
                            <b-th v-for="table_field in table_header" :key="table_field.index"
                                  class="f-90 bgray-100 py-2"
                            >
                                {{ table_field }}
                            </b-th>
                        </template>
                        <template v-else-if="$i18n.locale === 'ca'">
                            <b-th v-for="table_field in table_header_ca" :key="table_field.key"
                                  class="f-90 bgray-100 py-2"
                            >
                                {{ table_field.label }}
                            </b-th>
                        </template>
                        <template v-else>
                            <b-th v-for="table_field in table_header_ea" :key="table_field.key"
                                  class="f-90 bgray-100 py-2"
                            >
                                {{ table_field.label }}
                            </b-th>
                        </template>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <template v-if="$i18n.locale === 'ko'">
                        <b-tr v-for="(table_item, index) in structure"
                              :key="table_item.id"
                        >
                            <b-td v-for="(table_field, no) in table_header"
                                  :key="table_field.id"
                                  class="align-middle f-90 py-2"
                                  :style="[{ 'max-width:100px': isIE }]"
                            >
                                <template
                                    v-if="table_item['noteditables'] && table_item['noteditables'].includes(table_field)">
                                    <span v-html="table_item[table_field]"></span>
                                </template>
                                <template v-else-if="table_item['dropdown'] && table_item['dropdown'][table_field]">
                                    <b-dropdown :id="`table-dropdown-${index}-${no}`"
                                                :text="mapDropDownData[index]?.[table_item[table_field]]?.[$i18n.locale]"
                                                variant="dark-border"
                                                size="sm"
                                                :disabled="disabled"
                                    >
                                        <b-dropdown-item-button
                                            v-for="(dropdown_item, dropdown_item_idx) in table_item['dropdown'][table_field]"
                                            :key="dropdown_item.id"
                                            @click="setDropdown(index, table_field, dropdown_item_idx)"
                                            class="f-90"
                                            :active="dropdown_item == table_item[`${table_field}`]"
                                        >
                                            {{ dropdown_item }}
                                        </b-dropdown-item-button>
                                    </b-dropdown>
                                </template>

                                <template
                                    v-else-if="table_item['calculation'] && table_item['calculation'][table_field]">
                                    {{ cellCalculate(table_item.calculation[table_field]) }}
                                </template>

                                <template v-else>
                                    <b-input-group size="sm">
                                        <b-form-input
                                            class="pr-0 f-90"
                                            v-model.trim="table_item[table_field]"
                                            :placeholder="typeof table_item['placeholder'] !== 'undefined' && table_item?.placeholder[table_field] ? table_item.placeholder[table_field] : ''"
                                            :disabled="disabled"
                                            @update="handleUpdate"
                                            @blur="handleUpdate('input_text', true)"
                                            v-number-format="typeof table_item['input_type'] !== 'undefined' && table_item?.input_type[table_field] ? table_item.input_type[table_field] : 'text'"
                                        />
                                        <b-input-group-append>
                                            <b-button
                                                class="f-80"
                                                variant="icon-append"
                                                @click.stop.prevent="$bvModal.show(`td-${table_item['구분']}-${sub_code}-${index}-${no}`)"
                                                :disabled="disabled"
                                            >
                                                <fa icon="pen"></fa>
                                            </b-button>
                                        </b-input-group-append>

                                        <b-modal :ref="`td-${table_item['구분']}-${sub_code}-${index}-${no}`"
                                                 :id="`td-${table_item['구분']}-${sub_code}-${index}-${no}`"
                                                 :title="table_field ? table_field : $t('내용 입력')"
                                                 @ok="handleOK"
                                                 :ok-title="$t('저장')"
                                                 :cancel-title="$t('닫기')"
                                        >
                                            <b-textarea v-model="table_item[table_field]"
                                                        rows="4"
                                                        :disabled="disabled"
                                                        v-number-format="typeof table_item['input_type'] !== 'undefined' && table_item?.input_type[table_field] ? table_item.input_type[table_field] : 'text'"
                                            />
                                        </b-modal>
                                    </b-input-group>
                                </template>
                            </b-td>
                        </b-tr>
                    </template>
                    <template v-else>
                        <b-tr v-for="(table_item, index) in structure" :key="table_item.id">
                            <b-td v-for="(table_field, no) in $data[`table_header${lang_append}`]"
                                  :key="table_field.key"
                                  class="align-middle f-90 py-2"
                                  :style="[{ 'max-width:100px;': isIE }]"
                            >
                                <template
                                    v-if="table_item['noteditables'] && table_item['noteditables'].includes(table_field.key)">
                                    <span v-html="table_item[table_field.key + lang_append]"></span>
                                </template>

                                <template
                                    v-else-if="table_item['dropdown'] && table_item['dropdown'].hasOwnProperty(table_field.key)">
                                    <b-dropdown
                                        :id="`table-dropdown-${index}-${no}`"
                                        :text="mapDropDownData[index]?.[table_item[table_field.key]]?.[$i18n.locale]"
                                        size="sm"
                                        variant="dark-border"
                                        :disabled="disabled"
                                    >
                                        <b-dropdown-item-button
                                            v-for="(dropdown_item, dropdown_item_idx) in table_item['dropdown'][`${table_field.key}${lang_append}`]"
                                            :key="dropdown_item.id"
                                            @click="setDropdown(index, table_field.key, dropdown_item_idx)"
                                            class="f-90"
                                            :active="dropdown_item === mapDropDownData[index]?.[table_item[table_field.key]]?.[$i18n.locale]"
                                        >
                                            {{ dropdown_item }}
                                        </b-dropdown-item-button>
                                    </b-dropdown>
                                </template>

                                <template
                                    v-else-if="table_item['calculation'] && table_item['calculation'].hasOwnProperty(table_field.key)">
                                    {{ cellCalculate(table_item.calculation[table_field.key]) }}
                                </template>

                                <template v-else>
                                    <b-input-group>
                                        <b-form-input class="pr-0 f-90"
                                                      v-model="table_item[table_field.key]"
                                                      v-number-format="!!table_item['input_type'] && typeof table_item['input_type'][table_field.key] !== 'undefined' && table_item['input_type'][table_field.key] ? table_item['input_type'][table_field.key] : 'text'"
                                                      @update="handleUpdate"
                                                      @blur="handleUpdate('input_text', true)"
                                                      :disabled="disabled"
                                                      :placeholder="table_item.placeholder[`${table_field.key}${lang_append}`]"
                                        />
                                        <b-input-group-append>
                                            <b-button
                                                class="f-80"
                                                variant="icon-append"
                                                @click.stop.prevent="$bvModal.show(`td-${table_item['구분']}-${sub_code}-${index}-${no}-en`)"
                                                :disabled="disabled"
                                            >
                                                <fa icon="pen"></fa>
                                            </b-button>
                                        </b-input-group-append>

                                        <b-modal :ref="`td-${table_item['구분']}-${sub_code}-${index}-${no}-en`"
                                                 :id="`td-${table_item['구분']}-${sub_code}-${index}-${no}-en`"
                                                 :title="table_field.key ? table_field.key : $t('입력')"
                                                 @ok="handleOK"
                                                 :ok-title="$t('저장')"
                                                 :cancel-title="$t('닫기')"
                                        >
                                            <b-textarea
                                                v-model="table_item[table_field.key]"
                                                rows="4"
                                                :disabled="disabled"
                                                v-number-format="typeof table_item['input_type'] !== 'undefined' && table_item['input_type'][table_field.key] ? table_item['input_type'][table_field.key] : 'text'"
                                            >
                                            </b-textarea>
                                        </b-modal>
                                    </b-input-group>
                                </template>
                            </b-td>
                        </b-tr>
                    </template>
                </b-tbody>
            </b-table-simple>

            <div v-if="has_sub_attachment(result, 'table')" class="rounded mt-2 mb-3 border-0 f-95 p-2 bg-tealgray100">
                <df-attached-file-url-sub
                    v-bind="for_attachment_info"
                    class="mt-1"
                    :key="for_attachment_info.is_loaded + Math.random()"
                    :sub_code="sub_code"
                    :sub_path="`structure[${item_idx}].element_contents[${element_idx}]`"
                    :label="label"
                    :disabled="disabled"
                    :audit_mode="audit_mode"
                >
                </df-attached-file-url-sub>
            </div>
        </template>
    </div>
</template>

<script>
// import * as ih from '@core_utils/util'
import DfAttachedFileUrlSub from "@core/components/client/components/subs/elements/DFAttachedFileURLSub.vue";
import {unlinkWarning} from "@core/utils/subComponent/unlinkWarning";
import {mapActions} from "vuex";

export default {
    name: 'df-element',
    components: {
        DfAttachedFileUrlSub,
    },
    props: {
        item_idx: {type: Number},
        element_idx: {type: Number},
        element_item: {type: Object},
        disabled: {type: Boolean},
        audit_mode: {type: Boolean},
        sub_code: {type: String},
        label: {type: String, default: null},
        for_attachment_info: {
            type: Object,
            default: () => ({
                sub_id: null,
                sub_init_id: null,
                sub_path_name: null,
                required_opt_attachment: null,
                company_id: null,
                company_name: null,
                campaign_id: null,
                previous: null,
                is_loaded: null,
                sub_data_contents: null,
                save_state: null,
            })
        },
    },
    data() {
        return {
            type: '',
            result: '',
            old_result: '',
            structure: null,
            table_title: null,
            table_description: null,
            table_header: [],
            table_header_ea: [],
            table_header_ca: [],
            code: Math.random() * 100000,
            mapDropDownData: {},
        }
    },
    computed: {
        lang_append() {
            const pair_append_locale = {
                'ko': '',
                'en': '_ea',
                'ca': '_ca'
            }
            return pair_append_locale[this.$i18n.locale]
        },
        has_sub_attachment() {
            return (item, type) => {
                
                
                let checkValue = false
                if (type === 'radio') {
                    if(this.for_attachment_info.sub_data_contents.result === '아니오' || this.result === '아니오'){
                        return false
                    }
                    
                    checkValue = this.result === item.value
                } else if (type === 'checkbox') {
                    checkValue = this.result.includes(item.value)
                }
                else if(type === 'input_text' || type === 'input_number') {
                    checkValue = !!item
                }
                else if (type === 'table') {
                    return this.for_attachment_info.required_opt_attachment && this.for_attachment_info.sub_id
                }


                return this.for_attachment_info.required_opt_attachment && checkValue && this.for_attachment_info.sub_id
            }
        },
        sub_path_name() {
            return (item) => {
                return `${this.for_attachment_info.sub_path_name} - ${item.value}`
            }
        }
    },
    watch: {
        element_item: {
            handler(){
                this.$nextTick(() => {
                    this.structure = JSON.parse(JSON.stringify(this.element_item.structure))
                    this.result = this.element_item.result
                })
            }
        } ,
        result(newValue, oldValue){
            this.old_result = oldValue
        }
    },
    mounted() {
        this.type = this.element_item.type
        this.result = this.element_item.result
        this.structure = JSON.parse(JSON.stringify(this.element_item.structure))

        if (this.type === 'table') {
            this.table_description = this.$i18n.locale === 'ko'
                ? this.element_item.table_description
                : this.$i18n.locale === 'en'
                    ? this.element_item.table_description_ea
                    : this.element_item.table_description_ca

            this.table_title = this.$i18n.locale === 'ko'
                ? this.element_item.table_title
                : this.$i18n.locale === 'en'
                    ? this.element_item.table_title_ea
                    : this.element_item.table_title_ca

            if (this.element_item.table_header) {
                this.table_header = this.element_item.table_header
                this.table_header_ea = this.element_item.table_header_ea
                this.table_header_ca = this.element_item.table_header_ca
            }

            const mapDropDownData = {}

            this.structure.forEach((elem, i) => {
                if(elem.dropdown == null) {
                    return
                }
                this.table_header.forEach((header) => {
                    if (elem.dropdown && elem.dropdown[header]) {
                        if (mapDropDownData[i] == null) {
                            mapDropDownData[i] = {};
                        }
                        elem.dropdown[header].forEach((item, idx) => {
                            mapDropDownData[i][item] = {
                                'ko': item,
                                'en': elem.dropdown[`${header}_ea`] ? elem.dropdown[`${header}_ea`][idx] : item,
                                'ca': elem.dropdown[`${header}_ca`] ? elem.dropdown[`${header}_ca`][idx] : item,
                            };
                        });
                    }
                });
            });
            
            this.mapDropDownData = JSON.parse(JSON.stringify(mapDropDownData))
        }
    },
    methods: {
        ...mapActions('attachments', ['unlinkAttachments']),
        handleOK($event) {
            if (!this.result.length) $event.preventDefault()
            this.handleUpdate()
        },
        setDropdown(str_index, table_field, contents_idx) {
            this.structure[str_index][`${table_field}`] = this.structure[str_index]['dropdown'][`${table_field}`][contents_idx]
            // ['', '_ea', '_ca'].forEach(lang => {
            //     if (this.structure[str_index]['dropdown'][`${table_field}${lang}`]) {
            //         this.structure[str_index][`${table_field}${lang}`] = this.structure[str_index]['dropdown'][`${table_field}${lang}`][contents_idx]
            //     }
            // })

            this.handleUpdate()
        },
        handleUpdate(type = null, is_blur = false) {
            // 라디오, 체크박스인 경우, 값 변경 시, 첨부파일 여부 체크
            if(type === 'radio' || type === 'checkbox') {
                let unlink_sub_attachments_obj = {}
                const temp_structure = JSON.parse(JSON.stringify(this.structure))

                if(type ==='radio'){
                    temp_structure.forEach((item, itemIdx) => {
                        if (typeof item.attachments !== 'undefined') {
                            // 선택한 답안이 아니면
                            if (item.value !== this.result) {
                                item.attachments.forEach((attachment) => {
                                    const sub_path = `structure[${this.item_idx}].element_contents[${this.element_idx}].structure[${itemIdx}]`
                                    unlink_sub_attachments_obj[`${attachment}-${sub_path}`] = {
                                        sub_path,
                                        storage_id: attachment
                                    }
                                })
                                item.attachments = []
                            }
                        }
                    })
                }
                if(type === 'checkbox'){
                    temp_structure.forEach((item, itemIdx) => {
                        if (typeof item.attachments !== 'undefined') {
                            // 선택한 답안이 아니면
                            if (!this.result.includes(item.value)) {
                                item.attachments.forEach((attachment) => {
                                    const sub_path = `structure[${this.item_idx}].element_contents[${this.element_idx}].structure[${itemIdx}]`
                                    unlink_sub_attachments_obj[`${attachment}-${sub_path}`] = {
                                        sub_path,
                                        storage_id: attachment
                                    }
                                })
                                item.attachments = []
                            }
                        }
                    })
                }

                // 삭제할 아이템이 있는지 여부 체크
                const unlink_sub_attachments = Object.values(unlink_sub_attachments_obj)
                if(unlink_sub_attachments.length > 0){
                    const h = this.$createElement;
                    
                    unlinkWarning(this, h)
                        .then(async (value) => {
                            if(!value) {
                                this.result = this.old_result
                                return
                            }
                            const unlinkForm = {
                                sub_id: this.for_attachment_info.sub_id,
                                company_id: this.for_attachment_info.company_id.toString(),
                                campaign_id: this.for_attachment_info.campaign_id.toString(),
                                inner_storage: []
                            }
                            unlink_sub_attachments.forEach(elem => {
                                unlinkForm.inner_storage.push({
                                    sub_path: elem.sub_path,
                                    storage_id: elem.storage_id,
                                })
                            })
                            await this.unlinkAttachments(unlinkForm) 
                            await this.proceedUpdate({temp_structure})
                        })
                }
                else {
                    this.proceedUpdate({type, is_blur})
                }
                
                return;
            } 
            
            this.proceedUpdate({type, is_blur})
        },
        proceedUpdate({temp_structure, type,is_blur}) {
            this.$nextTick(() => {
                let new_element_item = {
                    type: this.type,
                    result: this.result,
                    structure: temp_structure ?? this.structure,
                    table_header: this.table_header,
                    table_header_ea: this.table_header_ea,
                    table_header_ca: this.table_header_ca
                }
                if(this.type === 'table'){
                    new_element_item.attachments = this.for_attachment_info?.sub_data_contents?.structure?.[this.item_idx]?.element_contents?.[this.element_idx]?.attachments ?? []
                }
                this.$emit('change', this.item_idx, this.element_idx, new_element_item, type, is_blur)
            })
        },
        cellCalculate(str) {
            let var_item = []
            let calculation_item = []

            var_item = str.match(/([A-Z0-9\(\)]+)/gi)
            calculation_item = str.match(/([+-/*])/g)

            let result = ''

            //오류처리들
            if (!var_item[0]) {
                //console.log('셀 아이템이 없습니다')
                return false
            }

            if (var_item.length !== calculation_item.length + 1) {
                //console.log('셀 아이템과 연산자 개수가 맞지 않습니다.')
                return false
            }

            //만약 셀 참조일 경우, cellValue로 변환
            if (var_item[0].match(/[A-Z]/i)) result = this.cellValue(var_item[0])
            else result = String(var_item[0])

            for (let i = 0; i < calculation_item.length; i++) {
                if (var_item[i + 1].match(/[A-Z]/i)) {
                    var_item[i + 1] = this.cellValue(var_item[i + 1])
                } else {
                    var_item[i + 1] = String(var_item[i + 1])
                }
                result = result + calculation_item[i] + var_item[i + 1]
            }

            //console.log(result)
            result = eval(result)
            return result.toLocaleString(undefined, {maximumFractionDigits: 0})

        },
        showPlaceholder(table_item, table_field) {
            const has_placeholder = !this.isFieldEmpty(table_item.placeholder),
                has_placeholder_field = !this.isFieldEmpty(table_item['placeholder'][`${table_field}${this.lang_append}`])

            if (has_placeholder && has_placeholder_field) {
                return table_item['placeholder'][`${table_field}${this.lang_append}`]
            } else {
                return ''
            }
        }
    }
}
</script>

<style lang="scss">
.custom-radio,
.custom-checkbox {
    &.w-100 .custom-control-label {
        width: 95%;
    }
}

.element-check > label,
.element-check > label > span {
    min-width: 450px;
}
</style>
